<div [ngClass]="class" [class.embedded]="isEmbedded">
  @if (warningIcon) {
  <a360-icon class="alert-warning-icon" [icon]="'warning'" width="32px" height="32px"></a360-icon>
  }
  <span class="alert-text">
    <ng-content></ng-content>
  </span>
  <div class="dummy"></div>
  @if (dismissIcon) {
  <cross (click)="dismissed.emit()"></cross>
  }
</div>
